import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';

interface FolderNameDialogData {
    folder: string;
}


@Component({
    selector: 'dl-folder-name-dialog',
    templateUrl: './folder-name-dialog.component.html',
    styleUrls: ['./folder-name-dialog.component.scss']
})

export class FolderNameDialogComponent {
    public static $name: string = 'folderNameDialog';

    public folderFormControl: FormControl;
    public formGroup: FormGroup;

    constructor(
        private dialogRef: MatDialogRef<FolderNameDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: FolderNameDialogData
    ) {
    }

    public onCancelClick() {
        this.data.folder = '';
        this.dialogRef.close();
    }

    private get validators() {
        return [
            Validators.required,
            Validators.maxLength(255),
            Validators.pattern('^([a-zA-Z0-9_ !@#%&=;~`\\(\\)\\[\\]\\{\\}\\+\\^\\$]+\.?)*[a-zA-Z0-9_!@#%&=;~`\\(\\)\\[\\]\\{\\}\\+\\^\\$]+$')
        ];
    }
            

    public ngOnInit() {

        this.formGroup = new FormGroup({});
        this.folderFormControl = new FormControl(this.data.folder, this.validators);
        this.formGroup.addControl('folder', this.folderFormControl);

    }

    folderChanged() {
        this.data.folder = this.folderFormControl.value;
    }
}

